import {
    CLEAR_ACTIVITY_LOG,
    FETCH_ACTIVITY_LOG,
    LIST_ACTIVITY_LOG,
    LIST_ACTIVITY_LOG_MODULES
} from "./types";

const init = {
    isLoading: false,
    list: [],
    modules: [],
    page: 0,
    size: 50,
    totals: 0,
    filter: {
        startDate: "",
        endDate: "",
        module: "",
        username: "",
        page: 1,
        size: 50
    }
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_ACTIVITY_LOG:
            return {
                ...state,
                isLoading: true,
                filter: payload
            };
        case LIST_ACTIVITY_LOG:
            return {
                ...state,
                isLoading: false,
                list: payload.list ?? [],
                page: payload.page ?? state.page,
                size: payload.size ?? state.size,
                totals: payload.totals ?? state.totals,
                filter: payload.filter ?? state.filter
            };
        case LIST_ACTIVITY_LOG_MODULES:
            return {
                ...state,
                modules: payload ?? []
            };
        case CLEAR_ACTIVITY_LOG:
            return {
                ...init,
                modules: state.modules
            };
        default:
            return state;
    }
};
